<template>
  <div  style="max-width: 750px; margin: auto">
    <div v-if=false id="showImg">
      <div style="opacity: 1" class="alertcover"></div>
      <img id="imgPlace" src="" alt="" />
    </div>
    <div
      v-if="!showContent && !showGuide && false"
      style="
        width: 100%;
        height: 100vh;
        background-color: #ffffff;
        position: relative;
      "
    >
      <div
        style="
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
        "
      >
        <img src="../../assets/loading.gif" alt="" />
        <span
          style="
            position: relative;
            z-index: 1;
            display: inline-block;
            margin-top: -77px;
            font-size: 14px;
          "
          >页面正在加载中，请稍候</span
        >
      </div>
    </div>
    <!--    <div v-if="showNoHcp" style="width: 100%;height: 100vh;background-color: #333;position:fixed;z-index:9999;left:0;right:0;bottom:0;top:0;opacity: 0.5">-->
    <!--      <div style="display: block;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align:center;">-->
    <!--&lt;!&ndash;        <img src="../../assets/loading.gif" alt="">&ndash;&gt;-->
    <!--        <span style="position: relative;z-index: 1;display: inline-block;margin-top:-77px;font-size: 14px;">该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <div
      v-if="showContent && false"
      id="login"
      :style="showQRcode && isHCP&&!FromMedical ? 'padding-top: 16vh;height:84vh' : ''"
    >
      <div v-if="isEdit && !stepNext">
        <div style="position: relative">
          <img style="opacity: 1" src="../../assets/1111111.png" width="100%" />
          <div
            style="
              position: absolute;
              z-index: 1;
              top: 0;
              width: 100%;
              height: 100%;
              left: 0;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div v-if="isHCP" style="position: relative; top: -30px">
              <!-- HCP -->
              <div style="padding: 20px 0" class="t_c font18 colorWhite">
                <span class="font28">{{ postData.docName }} </span>
                <span style="vertical-align: sub" class="font12">{{
                  "医生"
                }}</span>
              </div>
              <div class="t_c">
                <img
                  v-if="!postData.headImageUrl"
                  width="100px"
                  height="100px"
                  style="border-radius: 1000px"
                  src="../../assets/userDefault.jpg"
                />
                <img
                  v-else
                  width="100px"
                  height="100px"
                  style="border-radius: 1000px"
                  :src="postData.headImageUrl"
                />
              </div>
            </div>
            <!-- 员工 -->
            <div v-else style="position: relative; top: -30px">
              <div style="padding: 20px 0" class="t_c font18 colorWhite">
                <span class="font28">{{ employeeInfo.chineseName }} </span>
                <span style="vertical-align: sub" class="font12">{{
                  "员工"
                }}</span>
              </div>
              <div class="t_c">
                <img
                  v-if="!employeeInfo.headImageUrl"
                  width="100px"
                  height="100px"
                  style="border-radius: 1000px"
                  src="../../assets/userDefault.jpg"
                />
                <img
                  v-else
                  width="100px"
                  height="100px"
                  style="border-radius: 1000px"
                  :src="employeeInfo.headImageUrl"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            position: relative;
            top: -30px;
            background-color: #fff;
            width: 90%;
            left: 5%;
            border-radius: 10px;
            box-shadow: 0px 0px 3px 0px #999;
          "
        >
          <div class="t_c p_t_b_5 bot_bottom font14">我的信息</div>
          <!-- isHCP:ture 医生 -->
          <div style="padding: 10px" v-if="isHCP">
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">医院:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  postData.instName
                }}</span>
              </div>
            </div>
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">科室:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  postData.department
                }}</span>
              </div>
            </div>
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">感兴趣领域:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  postData.fieldStr
                }}</span>
              </div>
            </div>
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">感兴趣适应症:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  postData.indicationStr
                }}</span>
              </div>
            </div>
            <!-- <div class="m_b_10">
              <div>
                <span style="width: 100px;vertical-align: top" class="d_i f_w">感兴趣领域:</span>
                <div style="width: calc(100% - 150px);vertical-align: top" class="d_i">
                  <contentSelect class="coverF newFont12" :disabled="true" :multiple="true" :width="'80%'" :title="'感兴趣的领域'" :chooseData="fieldList" :needReturn="'id'" :placeholder="''" :matchValue="'name'" :showValue="'{{name}}'"  v-model="postData.fieldsList"></contentSelect>
                </div>
              </div>
            </div> -->
          </div>
          <!-- isHCP:false 员工 -->
          <div style="padding: 10px" v-else>
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">员工号:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  employeeInfo.employeeId
                }}</span>
              </div>
            </div>
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">邮 箱:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  employeeInfo.email
                }}</span>
              </div>
            </div>
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">部 门:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  employeeInfo.department
                }}</span>
              </div>
            </div>
            <div class="m_b_10">
              <div>
                <span style="width: 100px" class="d_i f_w">职 位:</span
                ><span class="d_i NoWrap" style="width: calc(100% - 100px)">{{
                  employeeInfo.jobTitle
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="padding: 10px" class="t_c m_t_10 m_b_10" v-if="isHCP">
          <button
            @click="modifiy"
            style="width: 100%; padding: 2% 0; margin-bottom: 50px"
            class="redButton"
          >
            修改个人信息
          </button>
          <a
            style="font-size: 12px; text-decoration: underline"
            href="javascript:;"
            @click="delHcp($event)"
            >注销</a
          >
        </div>
        <div class="t_c" style="margin-top: 60px">
          <span @click="toAgree(1)" class="colorBlue"
            >《武田电子化信息平台隐私及使用政策》</span
          >
        </div>
      </div>
      <div v-if="!isEdit || (isEdit && stepNext)">
        <img
          src="../../assets/Picture1.png"
          :style="
            showQRcode && isHCP&&!FromMedical
              ? 'position: absolute;opacity: 0.2; width: 100%; height: 84vh;'
              : 'position: absolute;opacity: 0.2; width: 100%; height: 100vh;'
          "
        />
        <div style="position: relative; z-index: 2">
          <!-- tab -->
          <ul v-if="!stepNext" class="tabList">
            <li :class="{ activeTab: isHCP }" @touchstart="switchTab(true)">
              医疗卫生专业人士
            </li>
            <li
              v-if="!fromTakedaMeeting || FromMedical"
              :class="{ activeTab: !isHCP }"
              @touchstart="switchTab(false)"
            >
              武田员工
            </li>
            <li
              v-if="fromTakedaMeeting && !FromMedical"
              :class="{ activeTab: !isHCP }"
              @touchstart="switchTab(false)"
            >
              非医疗卫生专业人士
            </li>
          </ul>
          <!-- HCP -->
          <section v-if="isHCP">
            <div id="myImg" style="padding: 10% 0" class="t_c">
              <img
                style="visibility: hidden"
                src="../../assets/takitaLogo.png"
                width="30%"
              />
            </div>
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m">
                <i class="colorRed m_r_5">*</i>
                <i
                  style="vertical-align: baseline"
                  class="icon iconfont iconyonghu"
                ></i>
              </div>
              <div class="d_i v_m w80">
                <input
                  :disabled="(isEdit && postData.hcpType === 'Import') || isOce"
                  @input="nesgame()"
                  @blur="kickBack(2)"
                  style="
                    border: none;
                    font-size: 16px !important;
                    background-color: transparent;
                  "
                  placeholder="姓名"
                  class="allInput nameInput"
                  v-model="postData.docName"
                  type="text"
                />
              </div>
            </div>
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m" style="margin-right: 5px">
                <i class="colorRed m_r_5">*</i>
                <i
                  style="vertical-align: top"
                  class="icon iconfont iconsheng"
                ></i>
              </div>
              <div class="d_i v_m w80">
                <provinceCityPicker
                  :directPick="true"
                  :class="'backWhite'"
                  :disabled="(isEdit && postData.hcpType === 'Import') || isOce"
                  v-on:on-confirm="getCity"
                  :width="'80%'"
                  :title="'请选择您所在的省份'"
                  :chooseData="provList"
                  :needReturn="'province'"
                  :placeholder="'请选择省份'"
                  :matchValue="'province'"
                  :showValue="'{{province}}'"
                  v-model="postData.Province"
                ></provinceCityPicker>
              </div>
            </div>
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m" style="margin-right: 5px">
                <i class="colorRed m_r_5">*</i>
                <i
                  style="vertical-align: baseline"
                  class="icon iconfont iconshi"
                ></i>
              </div>
              <div class="d_i v_m w80">
                <provinceCityPicker
                  :directPick="true"
                  :class="'backWhite'"
                  :disabled="(isEdit && postData.hcpType === 'Import') || isOce"
                  v-on:on-confirm="getHospital"
                  :width="'80%'"
                  :title="'请选择您所在的城市'"
                  :chooseData="cityList"
                  :needReturn="'city'"
                  :placeholder="'请选择城市'"
                  :matchValue="'city'"
                  :showValue="'{{city}}'"
                  v-model="postData.City"
                ></provinceCityPicker>
              </div>
            </div>
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m">
                <i class="colorRed m_r_5">*</i>
                <i
                  style="
                    vertical-align: top;
                    font-size: 12px !important;
                    margin-left: -3px;
                  "
                  class="icon iconfont iconyiyuan"
                ></i>
              </div>
              <div class="d_i v_m w80">
                <contentSelect
                  :directPick="true"
                  :class="'backWhite'"
                  :needOther="true"
                  :disabled="(isEdit && postData.hcpType === 'Import') || isOce"
                  :needSearch="true"
                  :width="'100%'"
                  :title="'医院'"
                  :chooseData="hospitalList"
                  :needReturn="'instName'"
                  :placeholder="'请选择医院'"
                  :matchValue="'instName'"
                  :showValue="'{{instName}}'"
                  v-model="postData.instName"
                ></contentSelect>
              </div>
            </div>
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m" style="margin-right: 5px">
                <i class="colorRed m_r_5">*</i>
                <i
                  style="vertical-align: baseline; font-size: 14px !important"
                  class="icon iconfont iconkeshi1"
                ></i>
              </div>
              <div class="d_i v_m w80">
                <!-- v-on:on-confirm="getFields" -->
                <contentSelect
                  :directPick="true"
                  :class="'backWhite'"
                  :disabled="(isEdit && postData.hcpType === 'Import') || isOce"
                  :needSearch="true"
                  :width="'80%'"
                  :title="'科室'"
                  :chooseData="departList"
                  :needReturn="'description'"
                  :placeholder="'请选择科室'"
                  :matchValue="'description'"
                  :showValue="'{{description}}'"
                  v-model="postData.department"
                ></contentSelect>
              </div>
            </div>
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m" style="margin-right: 5px">
                <i class="colorRed m_r_5" style="visibility: hidden">*</i>
                <i
                  style="vertical-align: baseline; font-size: 14px !important"
                  class="icon iconfont icongongzuotai"
                ></i>
              </div>
              <div class="d_i v_m w80 NoWrap">
                <!-- <contentSelect :class="'backWhite'" :multiple="true" :width="'80%'" :title="'感兴趣的领域'" :chooseData="fieldList" :needReturn="'id'" :placeholder="'请选择您感兴趣的领域'" :matchValue="'name'" :showValue="'{{name}}'"  v-model="postData.fieldsList"></contentSelect> -->
                <fieldSelect
                  :class="'backWhite'"
                  :fieldList="fieldList"
                  :indicationList="indicationList"
                  @getAllFields="getAllFields"
                  @getAllIndicationList="getAllIndicationList"
                  @getSelectedIndication="getSelectedIndication"
                  @recoverFieldList="recoverFieldList"
                  @recoverIndicationList="recoverIndicationList"
                  :multiple="true"
                  :width="'80%'"
                  :update="this.isEdit && this.stepNext"
                  v-model="postData.fields_indications"
                  :placeholder="'请选择您感兴趣的领域/适应症'"
                >
                </fieldSelect>
              </div>
            </div>
          </section>
          <!-- 非HCP -->
          <section v-if="(!isHCP && fromTakedaMeeting && !FromMedical)">
            <div id="myImg" style="padding: 10% 0" class="t_c">
              <img
                style="visibility: hidden"
                src="../../assets/takitaLogo.png"
                width="30%"
              />
            </div>
            <!-- 11/18这一期先隐藏 -->
            <!-- <div class="noneHCP m_10">
              <p style="color:#333;"><i class="colorRed m_r_5">*</i><i class="icon iconfont icongongjubao1" style="font-size: 20px!important;"></i><span style="margin-left: 10px;">角色</span></p>
              <ul class="role-list">
                <li :class="{'role-item': true, 'activeRole': item.checked}" v-for="(item, index) in roleList" :key="index" @click="chooseRole(item, index)">{{item.roleName}}</li>
              </ul>
            </div> -->
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m">
                <i class="colorRed m_r_5">*</i>
                <i
                  style="vertical-align: baseline"
                  class="icon iconfont iconyonghu"
                ></i>
              </div>
              <div class="d_i v_m w80">
                <input
                  :disabled="isEdit"
                  @blur="kickBack(3)"
                  style="
                    border: none;
                    font-size: 16px !important;
                    background-color: transparent;
                  "
                  placeholder="请输入姓名"
                  class="allInput"
                  v-model="nonHCPData.name"
                  type="text"
                />
              </div>
            </div>
            <div
              style="border-bottom: 1px solid #999; padding: 2%"
              class="t_l m_10"
            >
              <div class="d_i v_m">
                <i class="colorRed m_r_5">*</i>
                <i
                  style="vertical-align: baseline"
                  class="icon iconfont iconzuzhijiagou"
                ></i>
              </div>
              <div class="d_i v_m w80">
                <input
                  :disabled="isEdit || isOce"
                  @blur="kickBack(4)"
                  style="
                    border: none;
                    font-size: 16px !important;
                    background-color: transparent;
                  "
                  placeholder="请输入组织/机构"
                  class="allInput"
                  v-model="nonHCPData.institution"
                  type="text"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
      <!-- v-if="!isEdit"-->
      <div
        v-if="!isEdit && (isHCP || fromTakedaMeeting || FromMedical) && showSignAgreeBook"
        style="padding: 10px; position: relative; z-index: 1"
      >
        <table>
          <tr>
            <td>
              <input
                id="agree"
                v-model="agree"
                hidden
                class="allCheckbox"
                type="checkbox"
              />
              <label for="agree"></label>
            </td>

            <td>
              <span>我已阅读并同意</span>
              <span @click="toAgree(1)" class="colorBlue"
                >《武田电子化信息平台隐私及使用政策》</span
              >
              <span>和</span>
              <span @click="toAgree(2)" class="colorBlue"
                >《用户使用协议》</span
              >
            </td>
          </tr>
        </table>
      </div>
      <div style="position: relative;z-index: 1" class="t_c m_10" v-if="isHCP || fromTakedaMeeting ||FromMedical">
        <button v-if="stepNext" @click="backToCenter" style="width: 40%;padding: 2% 0" class="cancelButtonTwo">返回</button>
        <button v-if="isEdit && stepNext" @click="register" style="width: 40%;padding: 2% 0" class="redButton">保 存</button>
        <button v-if="!isEdit && isHCP" @click="register" style="width: 100%;padding: 2% 0" class="redButton">注 冊</button>
        <div v-if="!isEdit && isHCP &&!FromMedical" class="loginTxt">
          <span style="display: block; height: 10%">其他登录方式</span>
          <img
            src="../../assets/ymt.png"
            alt=""
            height="30px"
            @click="ymtLogin"
            style="cursor: pointer"
          />
        </div>
        <button v-if="!isEdit && fromTakedaMeeting && !isHCP && !FromMedical" @click="registerNonHCP" style="width: 100%;padding: 2% 0" class="redButton">注 冊</button>
      </div>
    </div>
    <!-- 二维码 -->
    <div
      v-if="(showQRcode && isHCP && !noQRcode&&!FromMedical && false)"
      class="qrCode-container"
      ref="abc"
    >
      <div class="qrcode-box">
        <img id="topImg" v-if="imgUrl" :src="imgUrl" width="70%" alt="" />
      </div>
    </div>
    <!-- <div v-show="!showContent && showQRcode" style="position: fixed;left: 0;right: 0;top: 0;bottom:0;;display: flex;justify-content: center;align-items: center" >
      <div style="text-align: center">
        <p>关注“吾医空间”完成签到</p>
        <p style="margin: 10px 0;text-align: center">
          <span class="f_w">前沿咨询、线上展会、品牌学院，</span><br><span>属于你的学术成长空间！</span>
        </p>
        <img id="topImg" v-if="imgUrl" :src="imgUrl" width="70%" alt="">
        <p style="margin: 10px 0">长按识别二维码并关注</p>
      </div>
    </div> -->
    <!--<div v-if="showGuide" class="guideTofollow"></div>-->
    <div v-if="(showGuide && !FromMedical && false)" class="guideTofollowImg">
      <img src="../../assets/guide_background_prod.png" />
    </div>
    <!-- 解决由于跳转/api/wechat/oauth2/authorize链接（网络慢的情况下），导致无法进去register页面加载loading效果 -->
    <div v-if="false">
      <iframe
        :src="iframeUrl"
        frameborder="0"
        style="width: 100%"
        scrolling="auto"
      ></iframe>
    </div>

    <div class="guideTofollowImg">
      <!-- <img src="../../assets/guide_background_prod.png" /> -->
      <span>Loading...</span>
    </div>

    <!-- <div style="width:60px;height:60px;background-color: antiquewhite;" @click="ceshi()"></div> -->
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>

</template>

<script>
import Index from "../index/index.vue";
import fieldSelect from "./fieldSelect";
import agreeBookDialog from "./agreeBookDialog";
export default {
  name: "login",
  data() {
    return {
      baseUrl: process.env.config.baseUrl,
      stepNext: false,
      isEdit: false,
      FromMedical: false,
      ArticleFromYMT:false,
      showSignAgreeBook:true,
      agree: false,
      showContent: false,
      showQRcode: false,
      postData: window.localStorage.getItem("registerUserInfo")
        ? JSON.parse(window.localStorage.getItem("registerUserInfo"))
        : {
            docName: "",
            headImageUrl: "",
            department: "",
            Province: "",
            instName: "",
            selfInstName: "",
            hcpType: "",
            fieldsList: "",
            fields: [],
            indications: [],
            fieldIds: [],
            City: "",
            selectedIndtItems: [],
            selectedFieldItems: [],
            fields_indications: "",
            fieldStr: "",
            indicationStr: "",
          },
      originPostData: {
        docName: "",
        headImageUrl: "",
        department: "",
        Province: "",
        instName: "",
        selfInstName: "",
        hcpType: "",
        fieldsList: "",
        fields: [],
        City: "",
      },
      needReturnData: {},
      imgUrl: "",
      loginName: "",
      password: "",
      departList: [],
      fieldList: [],
      provList: [],
      hospitalList: [],
      cityList: [],
      openId: "",
      returnurl: decodeURIComponent(this.$route.query.returnurl || ""),
      oriUrl: this.$route.query.returnurl || "",
      needReturn: this.$route.query.needReturn || "",
      meetingemscode: this.$route.query.meetingemscode || "",
      takedacode: this.$route.query.takedacode || "",
      NewerTag: this.$route.query.NewerTag || '',
      FromOceTag: this.$route.query.isOce || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      docCode: "",
      isHCP: true,
      indicationList: [],
      userStatus: "",
      roleList: [],
      domainUrl: [],
      fromTakedaMeeting: false, // 是否从武家会议跳转过来
      noQRcode: this.$route.query.noQRcode || "", // 是否从武家会议跳转过来
      showNoHcp: false, // 是否从武家会议跳转过来
      employeeInfo: {},
      nonHCPData: {
        name: "",
        institution: "",
        roleId: "",
        roleName: "",
        openId: "",
      },
      needRegisterData: this.$route.query.needRegisterData || "", // 是否需要将注册信息通过returnurl传回去
      showGuide: false,
      isOce: false,
      iframeUrl: "",
      ABDialogShow: false,
      isToGetType:''
    };
  },
  components: {
    fieldSelect,
    Index,
    agreeBookDialog
  },
  created() {
    this.getAllowDominList();
  },
  mounted() {
    if (process.env.config.seviceUrl.indexOf("wechatweb.takeda.com.cn") > -1) {
      document.title = "吾医空间";
    } else {
      document.title = "吾医空间测试号";
    }
  },
  methods: {    
    ymtLogin() {
      // 跳转至医脉通取得授权
      // 拼接跳转Url
      let tempDoccode = ''
      if (
        this.$route.query.docCode &&
        this.$route.query.docCode !== 'undefined' &&
        this.$route.query.docCode !== undefined
      ) {
        tempDoccode = this.$route.query.docCode
      }
      this.$router.push({
        path: '/ymtLogin',
        query: {
          redirectUrl: this.returnurl,
          toLogin: true,
          docCode: tempDoccode,
          openId: this.openId,
          meetingemscode: this.meetingemscode,
          needRegisterData: this.needRegisterData,
        },
      })
    },
    ceshi() {
      this.ABDialogShow = true;
    },
    getNoHcp() {
      let NoData = {
        openId: this.openId,
        returnurl: this.returnurl,
      };
      this.$axiox.postNoRes("/api/wechat/getNonHcpstatus", NoData).then((p) => {
        if (p.data.status === 1) {
          this.$commonJs.mobileDoubleComfirm({
            buttonType: "0",
            type: "warning",
            title: "提示",
            content:
              "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
            successFun: () => {
              this.$axiox
                .del(
                  `/api/hcp/DelHcpCustomer?openId=${localStorage.openId}&channel=M&type=auto`
                )
                .then((res) => {
                  console.log(res, "delHcp");
                  if (res === "True") {
                    this.$commonJs.showTips("您已注销成功");
                    window.setTimeout((t) => {
                      this.$commonJs.closeWindow();
                    }, 2000);
                  }
                });
            },
            errorFun: (err) => {},
          });
        }
      });
    },
    async getAllowDominList() {
      const domain = await this.$axiox.asyncGet(
        "/api/AppSettings/GetAppSettingByKey?key=AuthAllowDomains"
      );
      this.domainUrl = domain.split(",");
      console.log(this.domainUrl);
      // console.log(this.$route.query, 'this.$route.query')
      // 判断是否从武家会议跳转过来
      if (this.$route.query.hasOwnProperty("showQRCode")) {
        this.fromTakedaMeeting = true;
      } else {
        this.fromTakedaMeeting = false;
      }
      console.log(this.fromTakedaMeeting, "this.fromTakedaMeeting");

      if (this.$route.query.hasOwnProperty("FromMedical")) {
        this.FromMedical = true;
        window.location.href = process.env.config.vcPersonalCenter
      } else {
        this.FromMedical = false;
      }
       console.log("this.FromMedical------------------------------"+this.FromMedical);
       
      if (this.$route.query.hasOwnProperty("ArticleFromYMT")) {
        this.ArticleFromYMT = true;

      } else {
        this.ArticleFromYMT = false;

      }
       console.log("this.ArticleFromYMT------------------------------"+this.ArticleFromYMT);

      if (this.$route.query.isQiYe && this.$route.query.isQiYe === "true") {
        this.isHCP = false;
        window.localStorage.setItem("appId", this.$route.query.appid);
        window.localStorage.setItem("openId", this.$route.query.openid);
        window.localStorage.setItem(
          "returnUrl",
          encodeURIComponent(this.oriUrl || "")
        );
        window.location.href = `${process.env.config.baseUrl}/saml/login`;
        // 如果是员工登录，存一下openid，appid，returnurl
      }

  //-------------------------------------------------------------------------------------------------------------------------------

   //判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
   if(!this.jumptovctag){
    if (this.needReturn) {
          this.iframeUrl =
            process.env.config.baseUrl +
            "/api/wechat/oauth2/authorize?isOce="+this.FromOceTag+"&redirect_uri=" +
            encodeURIComponent(
              "https://" +
                window.location.host +
                "/register?needReturn=true&returnurl=" +
                encodeURIComponent(this.oriUrl || "")
                
            );
          window.location.href = this.iframeUrl;
          // let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/register?&needReturn=true&returnurl=' + encodeURIComponent((this.oriUrl || '')))
          // window.location.href = url
        } else {
          if (
            this.$route.query.docCode &&
            this.$route.query.docCode !== "undefined"
          ) {
            this.iframeUrl =
              process.env.config.baseUrl +
              "/api/wechat/oauth2/authorize?isOce="+this.FromOceTag+"&redirect_uri=" +
              encodeURIComponent(
                "https://" +
                  window.location.host +
                  "/register?docCode=" +
                  this.$route.query.docCode +
                  "&returnurl=" +
                  encodeURIComponent(this.oriUrl || "")
              );
            window.location.href = this.iframeUrl;
            // let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/register?docCode='+this.$route.query.docCode+'&returnurl=' + encodeURIComponent((this.oriUrl || '')))
            // window.location.href = url
          } else {
            this.iframeUrl =
              process.env.config.baseUrl +
              "/api/wechat/oauth2/authorize?isOce="+this.FromOceTag+"&redirect_uri=" +
              encodeURIComponent(
                "https://" +
                  window.location.host +
                  "/register?returnurl=" +
                  encodeURIComponent(this.oriUrl || "")
              );
            window.location.href = this.iframeUrl;
            // let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((this.oriUrl || '')))
            // window.location.href = url
          }
        }
    }


  //-------------------------------------------------------------------------------------------------------------------------------
    //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
    if(this.NewerTag.indexOf('Hcp')>=0){
      window.localStorage.setItem('isDOC', true);
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag.indexOf('Emp')>=0)
    {
      window.localStorage.removeItem("isDOC");
      window.localStorage.setItem('isEmployee', true);
    }
    else if(this.NewerTag.indexOf('NoHcp')>=0)
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }
//-------------------------------------------------------------------------------------------------------------------------------




      if (!localStorage.TaToken && !this.takedacode) {
        if (this.needReturn) {
          this.iframeUrl =
            process.env.config.baseUrl +
            "/api/wechat/oauth2/authorize?isOce="+this.FromOceTag+"&redirect_uri=" +
            encodeURIComponent(
              "https://" +
                window.location.host +
                "/register?needReturn=true&returnurl=" +
                encodeURIComponent(this.oriUrl || "")
            );
          window.location.href = this.iframeUrl;
          // let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/register?&needReturn=true&returnurl=' + encodeURIComponent((this.oriUrl || '')))
          // window.location.href = url
        } else {
          if (
            this.$route.query.docCode &&
            this.$route.query.docCode !== "undefined"
          ) {
            this.iframeUrl =
              process.env.config.baseUrl +
              "/api/wechat/oauth2/authorize?isOce="+this.FromOceTag+"&redirect_uri=" +
              encodeURIComponent(
                "https://" +
                  window.location.host +
                  "/register?docCode=" +
                  this.$route.query.docCode +
                  "&returnurl=" +
                  encodeURIComponent(this.oriUrl || "")
              );
            window.location.href = this.iframeUrl;
            // let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/register?docCode='+this.$route.query.docCode+'&returnurl=' + encodeURIComponent((this.oriUrl || '')))
            // window.location.href = url
          } else {
            this.iframeUrl =
              process.env.config.baseUrl +
              "/api/wechat/oauth2/authorize?isOce="+this.FromOceTag+"&redirect_uri=" +
              encodeURIComponent(
                "https://" +
                  window.location.host +
                  "/register?returnurl=" +
                  encodeURIComponent(this.oriUrl || "")
              );
            window.location.href = this.iframeUrl;
            // let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((this.oriUrl || '')))
            // window.location.href = url
          }
        }
      } else {
        if (this.takedacode && !localStorage.TaToken) {
          console.log(1);
          const thens = this
          this.$axiox
            .get("/Login/GetTokenByCode?code=" + this.takedacode)
            .then( async (msg) => {
              localStorage.TaToken = msg.token;
              localStorage.appId = msg.appId;
              localStorage.openId = msg.openId;
              this.openId = msg.openId;
              this.docCode = this.$route.query.docCode;
              this.isOce = false;
              this.getNoHcp();

              const hcisEmployee = window.localStorage.getItem('isEmployee')
              //如果没有缓存
              if(hcisEmployee==undefined || hcisEmployee=='' || hcisEmployee ==null){
                // 调取接口
                const myres = await this.$axiox.post('/api/wechat/getUserType',{openid:msg.openId})
                if(myres.status===1){
                  thens.isToGetType = ''
                  //医生
                }else if(myres.status===2){
                  thens.isToGetType = 'emp'
                  //员工
                }else{
                  thens.isToGetType = ''
                }
              }

              if (this.returnurl) {
                console.log(2);
                console.log(this.returnurl);
                // let isEmployee = JSON.parse(
                //   window.localStorage.getItem("isEmployee")
                // );
                let isEmployee = null
                if(this.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))){
                   isEmployee = true
                }else{
                  isEmployee = false
                }
                // let requestUrl1 = ''
                let allAxiox = "";
                if (isEmployee) {
                  // requestUrl1 = process.env.config.baseUrl + '/api/wechat/getEmployee/' + encodeURIComponent(this.returnurl)
                  let data = {
                    openId: this.openId,
                    returnurl: this.returnurl,
                  };
                  allAxiox = this.$axiox.postNoRes(
                    process.env.config.baseUrl + "/api/wechat/getEmployee",
                    data
                  );
                } else {
                  let data = {
                    openid: this.openId,
                    // returnurl: encodeURIComponent(this.returnurl)
                    returnurl: this.returnurl,
                  };
                  // requestUrl1 = (process.env.config.baseUrl + '/api/wechat/getDoctor/', data)
                  allAxiox = this.$axiox.postNoRes(
                    process.env.config.baseUrl + "/api/wechat/getDoctor",
                    data
                  );
                }

                const thens = this
                // this.$axiox.getNoRes(process.env.config.baseUrl + requestUrl1 + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl)).then(msg => {
                allAxiox.then((msg) => {
                  console.log('我是有takedacode,我的接口内容是',msg)
                  if (msg.isSuccess) {

                    

                    console.log(`我的isEmployee是${thens.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))};status是${msg.data.status};(msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)判断为${(msg.data.isFollowed ||
                        thens.fromTakedaMeeting ||
                        thens.noQRcode)};needReturn值为${thens.needReturn};domainUrl为${thens.domainUrl},它的长有${thens.domainUrl.length}`)

                    if(this.ArticleFromYMT){

                      msg.data.isFollowed=true;

                    }

                    console.log(4);
                    this.userStatus = msg.data.status;

                    if(msg.data.status!==1 && thens.isToGetType === 'emp'){
                      this.userStatus = 1
                    }

                    if ( 
                      !this.fromTakedaMeeting &&
                      !this.noQRcode &&
                      !msg.data.isFollowed      
                    ) {
                      this.showGuide = true;
                      return;
                    }
                    


                    if (
                      this.userStatus === 1 &&
                      (msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)
                    ) {
                      let isEmployee = null
                      if(this.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))){
                        isEmployee = true
                      }else{
                        isEmployee = false
                      }

                      

                      this.isHCP = !isEmployee;
                      console.log(this.needReturn, "this.needReturn");
                      if (this.needReturn && this.needReturn === "true") {
                        // alert(1)
                        for (let i = 0; i < this.domainUrl.length; i++) {
                          if (
                            decodeURIComponent(this.returnurl).indexOf(
                              this.domainUrl[i]
                            ) >= 0
                          ) {
                            // alert('1' + decodeURIComponent(this.returnurl))

                            window.location.href = this.$commonJs.returnQuery2(
                              decodeURIComponent(this.returnurl),
                              { openId: this.openId }
                            );


                            return;
                          }
                        }
                      }
                      let requestUrl2 = "";
                      if (isEmployee && this.userStatus !== 4) {
                        requestUrl2 = this.$axiox.getNoRes(
                          "/Login/EmployeeWxUserInfo?openId=" + this.openId
                        );
                      } else {
                        let data = {
                          openId: this.openId,
                        };
                        requestUrl2 = this.$axiox.postNoRes(
                          "/Login/WxUserInfo",
                          data
                        );
                      }
                      requestUrl2.then((msg) => {
                        console.log(5);
                        this.isEdit = true;
                        if (isEmployee) {
                          this.employeeInfo = msg.data;
                        } else {
                          this.postData.docName = msg.data.docName
                            ? msg.data.docName
                            : msg.data.cdwD_DOCName;
                          this.postData.hcpType = msg.data.hcpType;
                          this.postData.headImageUrl = msg.data.headImageUrl;
                          this.postData.department = msg.data.department
                            ? msg.data.department
                            : msg.data.cdwD_Department;
                          this.postData.Province = msg.data.province
                            ? msg.data.province
                            : msg.data.cdwD_Province;
                          this.getCity((p) => {
                            this.postData.City = msg.data.city
                              ? msg.data.city
                              : msg.data.cdwD_City;
                            this.getHospital((p) => {
                              this.postData.instName = msg.data.instName
                                ? msg.data.instName
                                : msg.data.cdwD_InstName;
                              this.getFields((p) => {
                                console.log(p);
                                this.postData.fieldsList = "";
                                this.postData.fields = [];

                                for (
                                  let i = 0;
                                  i < msg.data.fields.length;
                                  i++
                                ) {
                                  this.postData.fieldsList +=
                                    msg.data.fields[i].id + ",";
                                  this.postData.fields.push(
                                    msg.data.fields[i].id
                                  );
                                }
                                this.postData.fieldsList =
                                  this.postData.fieldsList.substring(
                                    0,
                                    this.postData.fieldsList.length - 1
                                  );

                                this.postData.selectedIndtItems =
                                  msg.data.indications;
                                this.postData.indications =
                                  msg.data.indications.map((val) => val.id);
                                this.postData.selectedFieldItems =
                                  msg.data.fields;
                                this.postData.fieldIds = msg.data.fields.map(
                                  (val) => val.id
                                );
                                this.fieldList = p.map((val) => {
                                  return {
                                    checked: this.postData.fieldIds.some(
                                      (v) => v === val.id
                                    ),
                                    ...val,
                                  };
                                });
                                this.getAllIndicationList(
                                  this.postData.fieldIds,
                                  this.postData.selectedFieldItems
                                );
                                console.log(
                                  this.fieldList,
                                  "this.fieldList---------this.fieldList"
                                );
                              });
                            });
                          });
                        }
                        this.$nextTick((p) => {
                          this.showContent = true;
                        });
                      });
                    }
                    if (
                      this.userStatus === 2 &&
                      (msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)
                    ) {
                      this.showContent = true;
                      this.showQRcode = false;
                    }
                    console.log(6);
                    if (
                      this.userStatus === 3 &&
                      (msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)
                    ) {
                      console.log(7);
                      this.showContent = true;
                      if (this.noQRcode) {
                        return;
                      }
                      this.showQRcode = true;
                      // this.imgUrl = msg.data.url
                      this.imgUrl = msg.data.img; // 带logo的base64格式
                      this.$nextTick((p) => {
                        document.getElementById("topImg").onclick = function (
                          e
                        ) {
                          var top = e.target.y;
                          var left = e.target.x;
                          var width = e.target.offsetWidth;
                          var height = e.target.offsetHeight;
                          var img = document.getElementById("imgPlace");
                          var showImg = document.getElementById("showImg");
                          img.src = e.target.src;
                          img.style.top = top + "px";
                          img.style.left = left + "px";
                          img.style.width = width + "px";
                          img.style.height = height + "px";
                          img.style.display = "block";
                          showImg.style.display = "flex";
                          var bodyHeight = showImg.clientHeight;
                          var clientWidth = showImg.clientWidth;
                          if (
                            (bodyHeight - height) / 2 -
                              (clientWidth - width) / 2 <
                            0
                          ) {
                            showImg.style.display = "block";
                          }
                          setTimeout(function () {
                            showImg.style.opacity = 1;
                            if (
                              (bodyHeight - height) / 2 -
                                (clientWidth - width) / 2 <
                              0
                            ) {
                              img.style.marginTop = 20 + "px";
                              img.style.marginBottom = 20 + "px";
                              img.style.position = "relative";
                              img.style.top = 0 + "px";
                            } else {
                              img.style.top =
                                (bodyHeight - height) / 2 -
                                (clientWidth - width) / 2 +
                                "px";
                            }
                            img.style.left = 0 + "px";
                            img.style.width = clientWidth + "px";
                            img.style.height =
                              clientWidth - width + height + "px";
                            setTimeout(function () {
                              img.onclick = function () {
                                img.style.top = top + "px";
                                img.style.left = left + "px";
                                img.style.width = width + "px";
                                img.style.height = height + "px";
                                showImg.style.opacity = 0;
                                setTimeout(function () {
                                  img.style.display = "none";
                                  showImg.style.display = "none";
                                }, 500);
                              };
                            }, 500);
                          }, 10);
                        };
                        // 给头部二维码qrCode-container定高，解决安卓软键盘弹出压缩背景图的问题
                        let h =
                          window.innerHeight ||
                          document.documentElement.clientHeight ||
                          document.body.clientHeight;
                        this.$nextTick(() => {
                          console.log(this.$refs.abc, "abc-----ref");
                          this.$refs.abc.style.height =
                            (h * 0.16).toFixed(1) + "px";
                        });
                      });
                    }
                  }
                });
              } else {
                console.log(3);
                // let isEmployee = JSON.parse(
                //   window.localStorage.getItem("isEmployee")
                // );

                const thens = this

                let isEmployee = null
                if(this.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))){
                   isEmployee = true
                }else{
                  isEmployee = false
                }
                // let requestUrl1 = ''
                let allAxiox = "";
                if (isEmployee) {
                  // requestUrl1 = '/api/wechat/getEmployee/'
                  let data = {
                    openId: this.openId,
                    // returnurl: encodeURIComponent(this.returnurl)
                    returnurl: this.returnurl,
                  };
                  allAxiox = this.$axiox.postNoRes(
                    process.env.config.baseUrl + "/api/wechat/getEmployee",
                    data
                  );
                } else {
                  // requestUrl1 = '/api/wechat/getDoctor/'
                  // this.docCode=''
                  // // 只有oce的会传一个docCode过来
                  // if(this.$route.query.docCode){
                  //   this.docCode="&docCode="+this.$route.query.docCode
                  // }
                  let data = {
                    openid: this.openId,
                    // returnurl: encodeURIComponent(this.returnurl),
                    returnurl: this.returnurl,
                    docCode: this.$route.query.docCode || "",
                  };
                  allAxiox = this.$axiox.postNoRes(
                    process.env.config.baseUrl + "/api/wechat/getDoctor",
                    data
                  );
                }
                allAxiox.then((msg) => {
                  console.log(8);
                  if (msg.isSuccess) {

                    if(this.ArticleFromYMT){

                      msg.data.isFollowed=true;

                    }

                    this.userStatus = msg.data.status;

                    if(msg.data.status!==1 && thens.isToGetType === 'emp'){
                      this.userStatus = 1
                    }

                   
                    if (
                      !msg.data.isFollowed &&
                      !this.fromTakedaMeeting &&
                      !this.noQRcode
                    ) {
                      this.showGuide = true;
                      return;
                    }
                    if (
                      this.userStatus === 1 &&
                      (msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)
                    ) {
                      this.isHCP = !isEmployee;
                      let requestUrl2 = "";
                      if (isEmployee) {
                        requestUrl2 = this.$axiox.getNoRes(
                          "/Login/EmployeeWxUserInfo?openId=" + this.openId
                        );
                        // requestUrl2 = '/Login/EmployeeWxUserInfo?openId=' + this.openId
                      } else {
                        let data = {
                          openId: this.openId,
                        };
                        requestUrl2 = this.$axiox.postNoRes(
                          "/Login/WxUserInfo",
                          data
                        );
                        // requestUrl2 = '/Login/WxUserInfo?openId=' + this.openId
                      }
                      requestUrl2.then((msg) => {
                        // 有没有注册过
                        console.log(9);
                        if (msg.isSuccess) {

                          if(this.ArticleFromYMT){

                            msg.data.isFollowed=true;

                          }


                          
                          this.isEdit = true;
                          if (isEmployee) {
                            this.employeeInfo = msg.data;
                          } else {
                            this.postData.docName = msg.data.docName
                              ? msg.data.docName
                              : msg.data.cdwD_DOCName;
                            this.postData.hcpType = msg.data.hcpType;
                            this.postData.headImageUrl = msg.data.headImageUrl;
                            this.postData.department = msg.data.department
                              ? msg.data.department
                              : msg.data.cdwD_Department;
                            this.postData.Province = msg.data.province
                              ? msg.data.province
                              : msg.data.cdwD_Province;

                            this.getCity((p) => {
                              this.postData.City = msg.data.city
                                ? msg.data.city
                                : msg.data.cdwD_City;
                              this.getHospital((p) => {
                                this.postData.instName = msg.data.instName
                                  ? msg.data.instName
                                  : msg.data.cdwD_InstName;
                                this.getFields((p) => {
                                  console.log(p);
                                  this.postData.fieldsList = "";
                                  this.postData.fields = [];

                                  // this.postData.indications = []
                                  // this.postData.fieldIds = []
                                  // this.postData.selectedFieldItems = []
                                  // this.postData.selectedIndtItems = []
                                  // this.postData.fields_indications = ''

                                  for (
                                    let i = 0;
                                    i < msg.data.fields.length;
                                    i++
                                  ) {
                                    this.postData.fieldsList +=
                                      msg.data.fields[i].id + ",";
                                    this.postData.fields.push(
                                      msg.data.fields[i].id
                                    );
                                  }
                                  this.postData.fieldsList =
                                    this.postData.fieldsList.substring(
                                      0,
                                      this.postData.fieldsList.length - 1
                                    );

                                  this.postData.selectedIndtItems =
                                    msg.data.indications;
                                  this.postData.indications =
                                    msg.data.indications.map((val) => val.id);
                                  this.postData.selectedFieldItems =
                                    msg.data.fields;
                                  this.postData.fieldIds = msg.data.fields.map(
                                    (val) => val.id
                                  );
                                  this.fieldList = p.map((val) => {
                                    return {
                                      checked: this.postData.fieldIds.some(
                                        (v) => v == val.id
                                      ),
                                      ...val,
                                    };
                                  });
                                  this.getAllIndicationList(
                                    this.postData.fieldIds,
                                    this.postData.selectedFieldItems
                                  );
                                });
                              });
                            });
                          }
                          this.$nextTick((p) => {
                            this.showContent = true;
                          });
                        } else {
                          console.log(10);
                          if (window.sessionStorage.getItem("LsData")) {
                            // this.showContent = true
                            let msg = JSON.parse(
                              window.sessionStorage.getItem("LsData")
                            );
                            this.postData.docName = msg.docName;
                            this.postData.department = msg.department;
                            this.postData.hcpType = msg.hcpType;
                            this.postData.headImageUrl = msg.headImageUrl;
                            this.postData.Province = msg.Province;
                            this.getCity((p) => {
                              this.postData.City = msg.City;
                              this.getHospital((p) => {
                                this.postData.instName = msg.instName;
                                this.getFields((p) => {
                                  console.log(p);
                                  this.postData.fieldsList = msg.fieldsList;
                                  // this.postData.fields = []
                                  // for (let i = 0; i < msg.fields.length; i++) {
                                  //   this.postData.fieldsList += msg.fields[i].id + ','
                                  //   this.postData.fields.push(msg.fields[i].id)
                                  // }
                                  // this.postData.fieldsList = this.postData.fieldsList.substring(0, this.postData.fieldsList.length - 1)
                                });
                              });
                            });
                            this.$nextTick((p) => {
                              this.showContent = true;
                            });
                          }
                        }
                      });
                    }
                    // isOce 是oce扫码过来的
                    if (
                      this.userStatus === 2 &&
                      (msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)
                    ) {
                      this.showContent = true;
                      this.showQRcode = false;
                      console.log(11);
                      if (msg.data.isOce) {
                        this.isOce = true;
                        this.postData.isOce = true;
                        let data = msg.data.data;
                        this.postData.docName = data.docname;
                        this.postData.hcpType = data.hcpType;
                        this.postData.headImageUrl = data.headImageUrl;
                        this.postData.department = data.department;
                        this.postData.Province = data.province;

                        this.getCity((p) => {
                          this.postData.City = data.city
                            ? data.city
                            : data.cdwD_City;
                          this.getHospital((p) => {
                            this.postData.instName = data.instname;
                            this.getFields((p) => {
                              console.log(p);
                              this.postData.fieldsList = "";
                              this.postData.fields = [];
                              if (data.fields) {
                                for (let i = 0; i < data.fields.length; i++) {
                                  this.postData.fieldsList +=
                                    data.fields[i].id + ",";
                                  this.postData.fields.push(data.fields[i].id);
                                }
                              }
                              this.postData.fieldsList =
                                this.postData.fieldsList.substring(
                                  0,
                                  this.postData.fieldsList.length - 1
                                );

                              this.postData.selectedIndtItems =
                                data.indications;
                              if (data.indications) {
                                this.postData.indications =
                                  data.indications.map((val) => val.id);
                              }
                              this.postData.selectedFieldItems = data.fields;
                              if (data.fields) {
                                this.postData.fieldIds = data.fields.map(
                                  (val) => val.id
                                );
                              }
                              this.fieldList = p.map((val) => {
                                return {
                                  checked: this.postData.fieldIds.some(
                                    (v) => v == val.id
                                  ),
                                  ...val,
                                };
                              });
                              this.getAllIndicationList(
                                this.postData.fieldIds,
                                this.postData.selectedFieldItems
                              );
                            });
                          });
                        });
                      }
                      if (window.sessionStorage.getItem("LsData")) {
                        this.showContent = true;
                        console.log(12);
                        let msg = JSON.parse(
                          window.sessionStorage.getItem("LsData")
                        );
                        this.postData.docName = msg.docName;
                        this.postData.department = msg.department;
                        this.postData.hcpType = msg.hcpType;
                        this.postData.headImageUrl = msg.headImageUrl;
                        this.postData.Province = msg.Province;
                        this.getCity((p) => {
                          this.postData.City = msg.City;
                          this.getHospital((p) => {
                            this.postData.instName = msg.instName;
                            this.getFields((p) => {
                              console.log(p);
                              this.postData.fieldsList = msg.fieldsList;
                              // this.postData.fields = []
                              // for (let i = 0; i < msg.fields.length; i++) {
                              //   this.postData.fieldsList += msg.fields[i].id + ','
                              //   this.postData.fields.push(msg.fields[i].id)
                              // }
                              // this.postData.fieldsList = this.postData.fieldsList.substring(0, this.postData.fieldsList.length - 1)
                            });
                          });
                        });
                      }
                    }
                    if (
                      this.userStatus === 3 &&
                      (msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)
                    ) {
                      this.showContent = true; // test
                      if (this.noQRcode) {
                        return;
                      }
                      this.showQRcode = true;
                      console.log(13);
                      // this.imgUrl = msg.data.url
                      this.imgUrl = msg.data.img; // 带logo的base64格式
                      this.$nextTick((p) => {
                        document.getElementById("topImg").onclick = function (
                          e
                        ) {
                          var top = e.target.y;
                          var left = e.target.x;
                          var width = e.target.offsetWidth;
                          var height = e.target.offsetHeight;
                          var img = document.getElementById("imgPlace");
                          var showImg = document.getElementById("showImg");
                          img.src = e.target.src;
                          img.style.top = top + "px";
                          img.style.left = left + "px";
                          img.style.width = width + "px";
                          img.style.height = height + "px";
                          img.style.display = "block";
                          showImg.style.display = "flex";
                          var bodyHeight = showImg.clientHeight;
                          var clientWidth = showImg.clientWidth;
                          if (
                            (bodyHeight - height) / 2 -
                              (clientWidth - width) / 2 <
                            0
                          ) {
                            showImg.style.display = "block";
                          }
                          setTimeout(function () {
                            showImg.style.opacity = 1;
                            if (
                              (bodyHeight - height) / 2 -
                                (clientWidth - width) / 2 <
                              0
                            ) {
                              img.style.marginTop = 20 + "px";
                              img.style.marginBottom = 20 + "px";
                              img.style.position = "relative";
                              img.style.top = 0 + "px";
                            } else {
                              img.style.top =
                                (bodyHeight - height) / 2 -
                                (clientWidth - width) / 2 +
                                "px";
                            }
                            img.style.left = 0 + "px";
                            img.style.width = clientWidth + "px";
                            img.style.height =
                              clientWidth - width + height + "px";
                            setTimeout(function () {
                              img.onclick = function () {
                                img.style.top = top + "px";
                                img.style.left = left + "px";
                                img.style.width = width + "px";
                                img.style.height = height + "px";
                                showImg.style.opacity = 0;
                                setTimeout(function () {
                                  img.style.display = "none";
                                  showImg.style.display = "none";
                                }, 500);
                              };
                            }, 500);
                          }, 10);
                        };
                        // 给头部二维码qrCode-container定高，解决安卓软键盘弹出压缩背景图的问题
                        let h =
                          window.innerHeight ||
                          document.documentElement.clientHeight ||
                          document.body.clientHeight;
                        this.$nextTick(() => {
                          console.log(this.$refs.abc, "abc-----ref");
                          this.$refs.abc.style.height =
                            (h * 0.16).toFixed(1) + "px";
                        });
                      });
                    }
                  }
                });
              }
            });
        } else {
          console.log(14);
          this.openId = localStorage.openId;
          this.docCode = this.$route.query.docCode;
          this.isOce = false;
          this.getNoHcp();
          const thens = this
          const hcisEmployee = window.localStorage.getItem('isEmployee')
              //如果没有缓存
              if(hcisEmployee==undefined || hcisEmployee=='' || hcisEmployee ==null){
                // 调取接口
                const myres = await this.$axiox.post('/api/wechat/getUserType',{openid:this.openId})
                if(myres.status===1){
                  thens.isToGetType = ''
                  //医生

                }else if(myres.status===2){
                  thens.isToGetType = 'emp'
                  //员工
                }else{
                  thens.isToGetType = ''
                }
              }
              
          // this.openId = 'dasjkdjasklds'
          if (this.returnurl) {
            console.log(this.returnurl);

            let isEmployee = null
                if(this.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))){
                   isEmployee = true
                }else{
                  isEmployee = false
                }
            // let requestUrl1 = ''
            let allAxiox = "";
            if (isEmployee) {
              // requestUrl1 = process.env.config.baseUrl + '/api/wechat/getEmployee/' + encodeURIComponent(this.returnurl)
              let data = {
                openId: this.openId,
                // returnurl: encodeURIComponent(this.returnurl)
                returnurl: this.returnurl,
              };
              allAxiox = this.$axiox.postNoRes(
                process.env.config.baseUrl + "/api/wechat/getEmployee",
                data
              );
            } else {
              let data = {
                openid: this.openId,
                // returnurl: encodeURIComponent(this.returnurl)
                returnurl: this.returnurl,
              };
              // requestUrl1 = (process.env.config.baseUrl + '/api/wechat/getDoctor/', data)
              allAxiox = this.$axiox.postNoRes(
                process.env.config.baseUrl + "/api/wechat/getDoctor",
                data
              );
            }
            const thens = this
            // this.$axiox.getNoRes(process.env.config.baseUrl + requestUrl1 + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl)).then(msg => {
            allAxiox.then((msg) => {
              console.log('我是有token的,我的接口内容是',msg)
              if (msg.isSuccess) {


                console.log(`我的isEmployee是${thens.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))};status是${msg.data.status};(msg.data.isFollowed ||
                        this.fromTakedaMeeting ||
                        this.noQRcode)判断为${(msg.data.isFollowed ||
                        thens.fromTakedaMeeting ||
                        thens.noQRcode)};needReturn值为${thens.needReturn};domainUrl为${thens.domainUrl},它的长有${thens.domainUrl.length}`)

if(this.ArticleFromYMT){

  msg.data.isFollowed=true;

}

                console.log(15);
                this.userStatus = msg.data.status;

                if(msg.data.status!==1 && thens.isToGetType === 'emp'){
                      this.userStatus = 1
                    }

                // 新用户需要校验是否是企业员工
                // if (msg.data.status != 1 && !this.$route.query.isQiYe && msg.data.isFollowed && !this.fromTakedaMeeting) {
                //   // alert('status != 1')
                //   // console.log(window.location.href, 'window.location.href')
                //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/companyauthorize?redirect_uri=' + encodeURIComponent(window.location.href)
                //   console.log(url, 'url')
                //   window.location.href = url
                //   return
                // }
                if (
                  !msg.data.isFollowed &&
                  !this.fromTakedaMeeting &&
                  !this.noQRcode
                ) {
                  this.showGuide = true;
                  return;
                }


                let isEmployee = null
                      if(this.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))){
                        isEmployee = true
                      }else{
                        isEmployee = false
                      }

                      
                        
                if (
                  this.userStatus === 1 &&
                  (msg.data.isFollowed ||
                    this.fromTakedaMeeting ||
                    this.noQRcode)
                ) {

                  
                  this.isHCP = !isEmployee;
                  if (this.needReturn && this.needReturn === "true") {
                    // alert(2)
                    // alert(decodeURIComponent(this.returnurl))
                    // alert(this.domainUrl.join(','))
                    for (let i = 0; i < this.domainUrl.length; i++) {
                      console.log(
                        decodeURIComponent(
                          this.returnurl
                            .replace("http://", "")
                            .replace("https://", "")
                        )
                      );
                      if (
                        decodeURIComponent(this.returnurl).indexOf(
                          this.domainUrl[i]
                        ) >= 0
                      ) {
                        // alert('2' + decodeURIComponent(this.returnurl))


                        window.location.href = this.$commonJs.returnQuery2(
                          decodeURIComponent(this.returnurl),
                          { openId: this.openId }
                        );

                    //   if(this.FromMedical){
                    //   window.location.href= decodeURIComponent(this.returnurl);
                    //   }else{
                    //   window.location.href = this.$commonJs.returnQuery2(
                    //    decodeURIComponent(this.returnurl),
                    //    { openId: this.openId }
                    //  );

                    //   }

                        return;
                      }
                    }
                  }
                  let requestUrl2 = "";
                  if (isEmployee && this.userStatus !== 4) {
                    requestUrl2 = this.$axiox.getNoRes(
                      "/Login/EmployeeWxUserInfo?openId=" + this.openId
                    );
                    // requestUrl2 = '/Login/EmployeeWxUserInfo?openId=' + this.openId
                  } else {
                    let data = {
                      openId: this.openId,
                    };
                    requestUrl2 = this.$axiox.postNoRes(
                      "/Login/WxUserInfo",
                      data
                    );
                    // requestUrl2 = '/Login/WxUserInfo?openId=' + this.openId
                  }
                  requestUrl2.then((msg) => {
                    this.isEdit = true;
                    console.log(16);
                    if (isEmployee) {
                      this.employeeInfo = msg.data;
                    } else {
                      this.postData.docName = msg.data.docName
                        ? msg.data.docName
                        : msg.data.cdwD_DOCName;
                      this.postData.hcpType = msg.data.hcpType;
                      this.postData.headImageUrl = msg.data.headImageUrl;
                      this.postData.department = msg.data.department
                        ? msg.data.department
                        : msg.data.cdwD_Department;
                      this.postData.Province = msg.data.province
                        ? msg.data.province
                        : msg.data.cdwD_Province;
                      this.getCity((p) => {
                        this.postData.City = msg.data.city
                          ? msg.data.city
                          : msg.data.cdwD_City;
                        this.getHospital((p) => {
                          this.postData.instName = msg.data.instName
                            ? msg.data.instName
                            : msg.data.cdwD_InstName;
                          this.getFields((p) => {
                            console.log(p);
                            this.postData.fieldsList = "";
                            this.postData.fields = [];

                            for (let i = 0; i < msg.data.fields.length; i++) {
                              this.postData.fieldsList +=
                                msg.data.fields[i].id + ",";
                              this.postData.fields.push(msg.data.fields[i].id);
                            }
                            this.postData.fieldsList =
                              this.postData.fieldsList.substring(
                                0,
                                this.postData.fieldsList.length - 1
                              );

                            this.postData.selectedIndtItems =
                              msg.data.indications;
                            this.postData.indications =
                              msg.data.indications.map((val) => val.id);
                            this.postData.selectedFieldItems = msg.data.fields;
                            this.postData.fieldIds = msg.data.fields.map(
                              (val) => val.id
                            );
                            this.fieldList = p.map((val) => {
                              return {
                                checked: this.postData.fieldIds.some(
                                  (v) => v === val.id
                                ),
                                ...val,
                              };
                            });
                            this.getAllIndicationList(
                              this.postData.fieldIds,
                              this.postData.selectedFieldItems
                            );
                            console.log(
                              this.fieldList,
                              "this.fieldList---------this.fieldList"
                            );
                          });
                        });
                      });
                    }
                    this.$nextTick((p) => {
                      this.showContent = true;
                    });
                  });
                }
                // alert('notInside')
                if (
                  this.userStatus === 2 &&
                  (msg.data.isFollowed ||
                    this.fromTakedaMeeting ||
                    this.noQRcode)
                ) {
                  this.showContent = true;
                  this.showQRcode = false;
                }
                if (
                  this.userStatus === 3 &&
                  (msg.data.isFollowed ||
                    this.fromTakedaMeeting ||
                    this.noQRcode)
                ) {
                  this.showContent = true;
                  if (this.noQRcode) {
                    return;
                  }
                  this.showQRcode = true;
                  // this.imgUrl = msg.data.url
                  this.imgUrl = msg.data.img; // 带logo的base64格式
                  this.$nextTick((p) => {
                    document.getElementById("topImg").onclick = function (e) {
                      var top = e.target.y;
                      var left = e.target.x;
                      var width = e.target.offsetWidth;
                      var height = e.target.offsetHeight;
                      var img = document.getElementById("imgPlace");
                      var showImg = document.getElementById("showImg");
                      img.src = e.target.src;
                      img.style.top = top + "px";
                      img.style.left = left + "px";
                      img.style.width = width + "px";
                      img.style.height = height + "px";
                      img.style.display = "block";
                      showImg.style.display = "flex";
                      var bodyHeight = showImg.clientHeight;
                      var clientWidth = showImg.clientWidth;
                      if (
                        (bodyHeight - height) / 2 - (clientWidth - width) / 2 <
                        0
                      ) {
                        showImg.style.display = "block";
                      }
                      setTimeout(function () {
                        showImg.style.opacity = 1;
                        if (
                          (bodyHeight - height) / 2 -
                            (clientWidth - width) / 2 <
                          0
                        ) {
                          img.style.marginTop = 20 + "px";
                          img.style.marginBottom = 20 + "px";
                          img.style.position = "relative";
                          img.style.top = 0 + "px";
                        } else {
                          img.style.top =
                            (bodyHeight - height) / 2 -
                            (clientWidth - width) / 2 +
                            "px";
                        }
                        img.style.left = 0 + "px";
                        img.style.width = clientWidth + "px";
                        img.style.height = clientWidth - width + height + "px";
                        setTimeout(function () {
                          img.onclick = function () {
                            img.style.top = top + "px";
                            img.style.left = left + "px";
                            img.style.width = width + "px";
                            img.style.height = height + "px";
                            showImg.style.opacity = 0;
                            setTimeout(function () {
                              img.style.display = "none";
                              showImg.style.display = "none";
                            }, 500);
                          };
                        }, 500);
                      }, 10);
                    };
                    console.log(17);
                    // 给头部二维码qrCode-container定高，解决安卓软键盘弹出压缩背景图的问题
                    let h =
                      window.innerHeight ||
                      document.documentElement.clientHeight ||
                      document.body.clientHeight;
                    this.$nextTick(() => {
                      console.log(this.$refs.abc, "abc-----ref");
                      this.$refs.abc.style.height =
                        (h * 0.16).toFixed(1) + "px";
                    });
                  });
                }
              }
            });
          } else {
            console.log(18);
            // let isEmployee = JSON.parse(
            //   window.localStorage.getItem("isEmployee")
            // );
            let isEmployee = null
                if(this.NewerTag.indexOf('Emp')>=0 || JSON.parse(window.localStorage.getItem("isEmployee"))){
                   isEmployee = true
                }else{
                  isEmployee = false
                }
            // let requestUrl1 = ''
            let allAxiox = "";
            if (isEmployee) {
              // requestUrl1 = '/api/wechat/getEmployee/'
              let data = {
                openId: this.openId,
                // returnurl: encodeURIComponent(this.returnurl)
                returnurl: this.returnurl,
              };
              allAxiox = this.$axiox.postNoRes(
                process.env.config.baseUrl + "/api/wechat/getEmployee",
                data
              );
            } else {
              // requestUrl1 = '/api/wechat/getDoctor/'
              // this.docCode=''
              // // 只有oce的会传一个docCode过来
              // if(this.$route.query.docCode){
              //   this.docCode="&docCode="+this.$route.query.docCode
              // }
              let data = {
                openid: this.openId,
                // returnurl: encodeURIComponent(this.returnurl),
                returnurl: this.returnurl,
                docCode: this.$route.query.docCode || "",
              };
              allAxiox = this.$axiox.postNoRes(
                process.env.config.baseUrl + "/api/wechat/getDoctor",
                data
              );
            }

            const thens = this
            allAxiox.then((msg) => {
              if (msg.isSuccess) {

if(this.ArticleFromYMT){

  msg.data.isFollowed=true;

}

                console.log(19);
                this.userStatus = msg.data.status;

                if(msg.data.status!==1 && thens.isToGetType === 'emp'){
                      this.userStatus = 1
                    }
                // if (msg.data.status != 1 && !this.$route.query.isQiYe && msg.data.isFollowed && !this.fromTakedaMeeting) {
                //   // alert('status != 1')
                //   // console.log(window.location.href, 'window.location.href')
                //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/companyauthorize?redirect_uri=' + encodeURIComponent(window.location.href)
                //   console.log(url, 'url')
                //   window.location.href = url
                //   return
                // }
                if (
                  !msg.data.isFollowed &&
                  !this.fromTakedaMeeting &&
                  !this.noQRcode
                ) {
                  this.showGuide = true;
                  return;
                }
                if (
                  this.userStatus === 1 &&
                  (msg.data.isFollowed ||
                    this.fromTakedaMeeting ||
                    this.noQRcode)
                ) {
                  this.isHCP = !isEmployee;
                  let requestUrl2 = "";
                  if (isEmployee) {
                    requestUrl2 = this.$axiox.getNoRes(
                      "/Login/EmployeeWxUserInfo?openId=" + this.openId
                    );
                  } else {
                    let data = {
                      openId: this.openId,
                    };
                    requestUrl2 = this.$axiox.postNoRes(
                      "/Login/WxUserInfo",
                      data
                    );
                  }
                  requestUrl2.then((msg) => {
                    // 有没有注册过
                    if (msg.isSuccess) {

if(this.ArticleFromYMT){

  msg.data.isFollowed=true;

}

                      this.isEdit = true;
                      if (isEmployee) {
                        this.employeeInfo = msg.data;
                      } else {
                        this.postData.docName = msg.data.docName
                          ? msg.data.docName
                          : msg.data.cdwD_DOCName;
                        this.postData.hcpType = msg.data.hcpType;
                        this.postData.headImageUrl = msg.data.headImageUrl;
                        this.postData.department = msg.data.department
                          ? msg.data.department
                          : msg.data.cdwD_Department;
                        this.postData.Province = msg.data.province
                          ? msg.data.province
                          : msg.data.cdwD_Province;

                        this.getCity((p) => {
                          this.postData.City = msg.data.city
                            ? msg.data.city
                            : msg.data.cdwD_City;
                          this.getHospital((p) => {
                            this.postData.instName = msg.data.instName
                              ? msg.data.instName
                              : msg.data.cdwD_InstName;
                            this.getFields((p) => {
                              console.log(p);
                              this.postData.fieldsList = "";
                              this.postData.fields = [];

                              // this.postData.indications = []
                              // this.postData.fieldIds = []
                              // this.postData.selectedFieldItems = []
                              // this.postData.selectedIndtItems = []
                              // this.postData.fields_indications = ''

                              for (let i = 0; i < msg.data.fields.length; i++) {
                                this.postData.fieldsList +=
                                  msg.data.fields[i].id + ",";
                                this.postData.fields.push(
                                  msg.data.fields[i].id
                                );
                              }
                              this.postData.fieldsList =
                                this.postData.fieldsList.substring(
                                  0,
                                  this.postData.fieldsList.length - 1
                                );

                              this.postData.selectedIndtItems =
                                msg.data.indications;
                              this.postData.indications =
                                msg.data.indications.map((val) => val.id);
                              this.postData.selectedFieldItems =
                                msg.data.fields;
                              this.postData.fieldIds = msg.data.fields.map(
                                (val) => val.id
                              );
                              this.fieldList = p.map((val) => {
                                return {
                                  checked: this.postData.fieldIds.some(
                                    (v) => v == val.id
                                  ),
                                  ...val,
                                };
                              });
                              console.log(20);
                              this.getAllIndicationList(
                                this.postData.fieldIds,
                                this.postData.selectedFieldItems
                              );
                            });
                          });
                        });
                      }
                      this.$nextTick((p) => {
                        this.showContent = true;
                      });
                    } else {
                      if (window.sessionStorage.getItem("LsData")) {
                        // this.showContent = true
                        let msg = JSON.parse(
                          window.sessionStorage.getItem("LsData")
                        );
                        this.postData.docName = msg.docName;
                        this.postData.department = msg.department;
                        this.postData.hcpType = msg.hcpType;
                        this.postData.headImageUrl = msg.headImageUrl;
                        this.postData.Province = msg.Province;
                        this.getCity((p) => {
                          this.postData.City = msg.City;
                          this.getHospital((p) => {
                            this.postData.instName = msg.instName;
                            this.getFields((p) => {
                              console.log(p);
                              this.postData.fieldsList = msg.fieldsList;
                              // this.postData.fields = []
                              // for (let i = 0; i < msg.fields.length; i++) {
                              //   this.postData.fieldsList += msg.fields[i].id + ','
                              //   this.postData.fields.push(msg.fields[i].id)
                              // }
                              // this.postData.fieldsList = this.postData.fieldsList.substring(0, this.postData.fieldsList.length - 1)
                            });
                          });
                        });
                        this.$nextTick((p) => {
                          this.showContent = true;
                        });
                      }
                    }
                  });
                }
                // isOce 是oce扫码过来的
                if (
                  this.userStatus === 2 &&
                  (msg.data.isFollowed ||
                    this.fromTakedaMeeting ||
                    this.noQRcode)
                ) {
                  this.showContent = true;
                  this.showQRcode = false;
                  if (msg.data.isOce) {
                    this.isOce = true;
                    this.postData.isOce = true;
                    let data = msg.data.data;
                    this.postData.docName = data.docname;
                    this.postData.hcpType = data.hcpType;
                    this.postData.headImageUrl = data.headImageUrl;
                    this.postData.department = data.department;
                    this.postData.Province = data.province;

                    this.getCity((p) => {
                      this.postData.City = data.city
                        ? data.city
                        : data.cdwD_City;
                      this.getHospital((p) => {
                        this.postData.instName = data.instname;
                        this.getFields((p) => {
                          console.log(p);
                          this.postData.fieldsList = "";
                          this.postData.fields = [];
                          if (data.fields) {
                            for (let i = 0; i < data.fields.length; i++) {
                              this.postData.fieldsList +=
                                data.fields[i].id + ",";
                              this.postData.fields.push(data.fields[i].id);
                            }
                          }
                          this.postData.fieldsList =
                            this.postData.fieldsList.substring(
                              0,
                              this.postData.fieldsList.length - 1
                            );

                          this.postData.selectedIndtItems = data.indications;
                          if (data.indications) {
                            this.postData.indications = data.indications.map(
                              (val) => val.id
                            );
                          }
                          this.postData.selectedFieldItems = data.fields;
                          if (data.fields) {
                            this.postData.fieldIds = data.fields.map(
                              (val) => val.id
                            );
                          }
                          this.fieldList = p.map((val) => {
                            return {
                              checked: this.postData.fieldIds.some(
                                (v) => v == val.id
                              ),
                              ...val,
                            };
                          });
                          this.getAllIndicationList(
                            this.postData.fieldIds,
                            this.postData.selectedFieldItems
                          );
                        });
                      });
                    });
                  }
                  if (window.sessionStorage.getItem("LsData")) {
                    this.showContent = true;
                    let msg = JSON.parse(
                      window.sessionStorage.getItem("LsData")
                    );
                    this.postData.docName = msg.docName;
                    this.postData.department = msg.department;
                    this.postData.hcpType = msg.hcpType;
                    this.postData.headImageUrl = msg.headImageUrl;
                    this.postData.Province = msg.Province;
                    this.getCity((p) => {
                      this.postData.City = msg.City;
                      this.getHospital((p) => {
                        this.postData.instName = msg.instName;
                        this.getFields((p) => {
                          console.log(p);
                          this.postData.fieldsList = msg.fieldsList;
                          // this.postData.fields = []
                          // for (let i = 0; i < msg.fields.length; i++) {
                          //   this.postData.fieldsList += msg.fields[i].id + ','
                          //   this.postData.fields.push(msg.fields[i].id)
                          // }
                          // this.postData.fieldsList = this.postData.fieldsList.substring(0, this.postData.fieldsList.length - 1)
                        });
                      });
                    });
                  }
                }
                if (
                  this.userStatus === 3 &&
                  (msg.data.isFollowed ||
                    this.fromTakedaMeeting ||
                    this.noQRcode)
                ) {
                  this.showContent = true; // test
                  if (this.noQRcode) {
                    return;
                  }
                  this.showQRcode = true;
                  // this.imgUrl = msg.data.url
                  this.imgUrl = msg.data.img; // 带logo的base64格式
                  this.$nextTick((p) => {
                    document.getElementById("topImg").onclick = function (e) {
                      var top = e.target.y;
                      var left = e.target.x;
                      var width = e.target.offsetWidth;
                      var height = e.target.offsetHeight;
                      var img = document.getElementById("imgPlace");
                      var showImg = document.getElementById("showImg");
                      img.src = e.target.src;
                      img.style.top = top + "px";
                      img.style.left = left + "px";
                      img.style.width = width + "px";
                      img.style.height = height + "px";
                      img.style.display = "block";
                      showImg.style.display = "flex";
                      var bodyHeight = showImg.clientHeight;
                      var clientWidth = showImg.clientWidth;
                      if (
                        (bodyHeight - height) / 2 - (clientWidth - width) / 2 <
                        0
                      ) {
                        showImg.style.display = "block";
                      }
                      setTimeout(function () {
                        showImg.style.opacity = 1;
                        if (
                          (bodyHeight - height) / 2 -
                            (clientWidth - width) / 2 <
                          0
                        ) {
                          img.style.marginTop = 20 + "px";
                          img.style.marginBottom = 20 + "px";
                          img.style.position = "relative";
                          img.style.top = 0 + "px";
                        } else {
                          img.style.top =
                            (bodyHeight - height) / 2 -
                            (clientWidth - width) / 2 +
                            "px";
                        }
                        img.style.left = 0 + "px";
                        img.style.width = clientWidth + "px";
                        img.style.height = clientWidth - width + height + "px";
                        setTimeout(function () {
                          img.onclick = function () {
                            img.style.top = top + "px";
                            img.style.left = left + "px";
                            img.style.width = width + "px";
                            img.style.height = height + "px";
                            showImg.style.opacity = 0;
                            setTimeout(function () {
                              img.style.display = "none";
                              showImg.style.display = "none";
                            }, 500);
                          };
                        }, 500);
                      }, 10);
                    };
                    // 给头部二维码qrCode-container定高，解决安卓软键盘弹出压缩背景图的问题
                    let h =
                      window.innerHeight ||
                      document.documentElement.clientHeight ||
                      document.body.clientHeight;
                    this.$nextTick(() => {
                      console.log(this.$refs.abc, "abc-----ref");
                      this.$refs.abc.style.height =
                        (h * 0.16).toFixed(1) + "px";
                    });
                  });
                }
              }
            });
          }
        }
      }
      this.getDepart();
      this.getProv();
      if (this.postData.Province) {
        let registerData = JSON.parse(JSON.stringify(this.postData));
        this.getCity((p) => {
          if (registerData.City) {
            this.postData.City = registerData.City;
            this.postData.instName = registerData.instName;
            this.getHospital((p) => {
              if (registerData.instName) {
                this.postData.instName = registerData.instName;
              }
            });
          }
        });
      }
      this.getAllFields();
      if (this.fromTakedaMeeting) {
        // 获取非医疗相关人员角色
        this.getNonHCPRoles();
      }

      setTimeout(() => {
        this.getSignDetail();
      }, 1000);
      
    },
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
         if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    setOtherIns(e) {
      this.postData.selfInstName = e;
    },
    nesgame() {
      this.postData.docName = this.postData.docName.replace(/\s+/g, "");
    },
    kickBack(type) {
      var str;
      if (type === 2 || type === 3) {
        if (type === 2) {
          str = this.postData.docName;
        } else {
          str = this.nonHCPData.name;
        }
        // var han = /^((?![\u3000-\u303F])[\u2E80-\uFE4F]|\·)*(?![\u3000-\u303F])[\u2E80-\uFE4F](\·)*$/;
        // if (str == '') {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   // this.postData.docName = ''
        //   return false;
        // }
        // if (!han.test(str)) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   // this.postData.docName = ''
        //   return false;
        // }
        // if (str.length < 2 || str.length > 9) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   // this.postData.docName = ''
        //   return false;
        // }
      }
      if (type === 4) {
        str = this.nonHCPData.institution;
        let reg1 = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
        if (!reg1.test(str)) {
          this.$commonJs.showTips("请您输入正确的组织/机构");
          return false;
        }
        if (str < 2 || str > 32) {
          this.$commonJs.showTips("请您输入正确的组织/机构");
          return false;
        }
      }
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollTop + 1);
        document.body.scrollTop >= 1 &&
          window.scrollTo(0, document.body.scrollTop - 1);
        if (document.getElementById("login")) {
          window.scrollTo(0, document.getElementById("login").scrollTop + 1);
          document.getElementById("login").scrollTop >= 1 &&
            window.scrollTo(0, document.getElementById("login").scrollTop - 1);
        }
      }, 10);
    },
    backToCenter() {
      window.location.reload();
    },
    modifiy() {
      this.originPostData = JSON.parse(JSON.stringify(this.postData));
      this.stepNext = true;
    },
    toAgree(type) {
      if (type === 1) {
        window.sessionStorage.setItem("LsData", JSON.stringify(this.postData));
        this.$router.push({ name: "agreeBook" });
      } else {
        window.sessionStorage.setItem("LsData", JSON.stringify(this.postData));
        this.$router.push({ name: "userAgreement" });
      }
    },
    getCity(callback) {
      this.postData.City = "";
      this.postData.instName = "";
      this.hospitalList = [];
      this.$axiox
        .get("/api/Dict/GetCities?province=" + this.postData.Province)
        .then((p) => {
          // this.cityList = []
          // for (let i = 0; i < p.length; i++) {
          //   let data = {
          //     name: p[i],
          //     id: i + 1
          //   }
          //   this.cityList.push(data)
          // }
          this.cityList = p.map((val) => {
            return {
              PinYin: val.cityPinYin,
              ...val,
            };
          });
          if (callback) {
            callback();
          }
        });
    },
    getProv() {
      this.$axiox.get("/api/Dict/GetProvinces").then((p) => {
        this.provList = p.map((val) => {
          return {
            PinYin: val.provincePinYin,
            ...val,
          };
        });
        // for (let i = 0; i < p.length; i++) {
        //   let data = {
        //     name: p[i],
        //     id: i + 1
        //   }
        //   this.provList.push(data)
        // }
      });
    },
    getDepart(callback) {
      this.$axiox.get("/api/Dict/GetHosDepts").then((p) => {
        this.departList = p;
        if (callback) {
          callback();
        }
      });
    },
    getHospital(callback) {
      this.postData.instName = "";
      this.hospitalList = [];
      if (this.postData.Province && this.postData.City) {
        let data = {
          Province: this.postData.Province.replace("直辖", ""),
          City: this.postData.City,
          PageIndex: 1,
          PageSize: 9999,
        };
        let url = this.$commonJs.returnQuery("/api/Dict/GetInstList", data);
        this.$axiox.get(url).then((p) => {
          let data = {
            id: -1,
            instCode: "",
            instName: "其它",
            province: "",
            city: "",
          };
          p.push(data);
          this.hospitalList = p;
          if (callback) {
            callback();
          }
        });
      }
    },
    getAllFields() {
      this.$axiox.get("/api/Dict/GetFields").then((p) => {
        this.fieldList = p.map((val) => {
          return {
            checked: this.postData.fieldIds.some((v) => v == val.id),
            ...val,
          };
        });
      });
    },
    getFields(callback) {
      this.$axiox.get("/api/Dict/GetFields").then((p) => {
        this.fieldList = p.map((val) => {
          return {
            checked: false,
            ...val,
          };
        });
        this.postData.fieldsList = "";
        this.postData.fields = [];
        if (callback) {
          callback(p);
        }
      });
    },
    register() {
      console.log(this.postData, "register----postData");
      //  && this.postData.fieldIds.length > 0 领域必填
      if (
        this.postData.docName &&
        this.postData.Province &&
        this.postData.City &&
        this.postData.instName &&
        this.postData.department
      ) {
        // let reg = /^((?![\u3000-\u303F])[\u2E80-\uFE4F]|\·)*(?![\u3000-\u303F])[\u2E80-\uFE4F](\·)*$/;
        // if (!reg.test(this.postData.docName)) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   return false;
        // }
        // if (this.postData.docName.length < 2 || this.postData.docName.length > 9) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   return false;
        // }
        // let fields = this.postData.fieldsList ? this.postData.fieldsList.split(',') : []
        // for (let i = 0; i < fields.length; i++) {
        //   fields[i] = parseInt(fields[i])
        // }
        let tempDoccode = "";
        if (
          this.$route.query.docCode &&
          this.$route.query.docCode !== "undefined" &&
          this.$route.query.docCode !== undefined
        ) {
          tempDoccode = this.$route.query.docCode;
        }
        let data = {
          openId: this.openId,
          docName: this.postData.docName,
          docCode: tempDoccode,
          province: this.postData.Province,
          city: this.postData.City,
          instName: this.postData.instName,
          department: this.postData.department,
          fieldIds: this.postData.fieldIds,
          indications: this.postData.indications,
          wuJiaMeetingId: "",
          isOce: this.$route.query.docCode ? true : false,
        };
        console.log(data, "register----data");
        if (this.isEdit) {
          this.$axiox.post("/Login/UpdateWxUserInfo", data).then((p) => {
            this.$commonJs.showTips("保存成功");
            window.sessionStorage.removeItem("LsData");
            if (this.returnurl) {
              setTimeout((p) => {
                if (this.needRegisterData && this.needRegisterData == "true") {
                  let registerData = {
                    docName: this.postData.docName,
                    headImageUrl: this.postData.headImageUrl,
                    Province: this.postData.Province,
                    instName: this.postData.instName,
                    selfInstName: this.postData.selfInstName,
                    hcpType: this.postData.hcpType,
                    City: this.postData.City,
                    openId: this.openId,
                  };
                  // alert(3)
                  for (let i = 0; i < this.domainUrl.length; i++) {
                    if (
                      decodeURIComponent(this.returnurl).indexOf(
                        this.domainUrl[i]
                      ) >= 0
                    ) {
                      window.location.href = this.$commonJs.returnQuery2(
                        decodeURIComponent(this.returnurl),
                        registerData
                      );

                    //   if(this.FromMedical){
                    //   window.location.href= decodeURIComponent(this.returnurl);
                    //   }else{
                    //   window.location.href = this.$commonJs.returnQuery2(
                    //    decodeURIComponent(this.returnurl),
                    //    registerData
                    //  );


                    //   }


                    }
                  }
                } else {
                  let registerData = {
                    openId: this.openId,
                  };
                  // alert(4)
                  for (let i = 0; i < this.domainUrl.length; i++) {
                    if (
                      decodeURIComponent(this.returnurl).indexOf(
                        this.domainUrl[i]
                      ) >= 0
                    ) {
                      window.location.href = this.$commonJs.returnQuery2(
                        decodeURIComponent(this.returnurl),
                        registerData
                      );

                    //   if(this.FromMedical){
                    //   window.location.href= decodeURIComponent(this.returnurl);
                    //   }else{
                    //   window.location.href = this.$commonJs.returnQuery2(
                    //    decodeURIComponent(this.returnurl),
                    //    registerData
                    //  );
                    //   }



                    }
                  }
                }
              }, 2000);
            } else {
              // // 重新获取用户信息
              // this.getUserInfo()
            }
          });
        } else {
          if (!this.agree) {
            this.$commonJs.showTips(
              "请先同意武田电子化信息平台隐私及使用政策！"
            );
            return;
          }
          if (this.meetingemscode) {
            data.hcptype = 5;
            data.meetingemscode = this.meetingemscode;
          }
          this.$axiox.post("/Login/Register", data).then((p) => {
            this.$commonJs.mobileDoubleComfirm({
              buttonType: "1",
              type: "warning",
              title: "提示",
              content: `您已注册成功`,
              successFun: (p) => {
                console.log("注册成功--------------------");
                window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
                window.localStorage.removeItem("registerUserInfo");
                window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
                window.localStorage.removeItem("isEmployee");
                if (this.returnurl) {
                  setTimeout((p) => {
                    if (
                      this.needRegisterData &&
                      this.needRegisterData == "true"
                    ) {
                      console.log("T--------------------"+this.returnurl);
                      let registerData = {
                        docName: this.postData.docName,
                        headImageUrl: this.postData.headImageUrl,
                        Province: this.postData.Province,
                        instName: this.postData.instName,
                        selfInstName: this.postData.selfInstName,
                        hcpType: this.postData.hcpType,
                        City: this.postData.City,
                        openId: this.openId,
                      };

                      window.location.href = this.$commonJs.returnQuery2(
                        decodeURIComponent(this.returnurl),
                        registerData
                      );

                    //   if(this.FromMedical){
                    //   window.location.href= decodeURIComponent(this.returnurl);
                    //   }else{
                    //   window.location.href = this.$commonJs.returnQuery2(
                    //    decodeURIComponent(this.returnurl),
                    //    registerData
                    //  );

                    //   }
                    
                    } else {
                      console.log("F--------------------"+this.returnurl);
                      let registerData = {
                        openId: this.openId,
                      };
                      if(this.FromMedical){
                      //this.clearcookie();
                      window.location.href= decodeURIComponent(this.returnurl);
                      }else{
                      window.location.href = this.$commonJs.returnQuery2(
                       decodeURIComponent(this.returnurl),
                       registerData
                     );
                      }
                    
                    }
                  }, 2000);
                } else {
                  // window.location.reload()
                  this.$commonJs.closeWindow();
                }
              },
            });
          });
        }
      } else {
        this.$commonJs.showTips("请检查必填项");
      }
    },
    clearcookie(){
      var keys=document.cookie.match(/[^ =;]+(?=\=)/g);
      console.log("document.cookie-=-----------------------"+document.cookie);
      console.log("Domain-=-----------------------"+document.domain);
      if(keys){
        for(var i=keys.length;i++;){
            document.cookie=keys[i]+ '=0;path=/;expires=Thu,01 Jan 1970 00:00:00 UTC';
            document.cookie=keys[i]+ '=0;path=/;domain=' + document.domain + ';expires=Thu,01 Jan 1970 00:00:00 UTC';
            document.cookie=keys[i]+ '=0;path=/;domain=takedamedical-uat.takeda.com.cn;expires=Thu,01 Jan 1970 00:00:00 UTC';
        }
      }
      console.log("Domain-=-----------------------"+document.domain);
      console.log("document.cookie-=-----------------------"+document.cookie);
    },
    switchTab(flag) {
      // 如果在一个页面同意隐私条款，切换页面时要取消
      this.agree = false;
      this.isHCP = flag;
      if ((!flag && !this.fromTakedaMeeting) || (!flag && this.FromMedical)) {
        this.showSignAgreeBook=false;
        window.localStorage.setItem(
          "returnUrl",
          encodeURIComponent(this.oriUrl || "")
        );
        window.location.href = `${process.env.config.baseUrl}/saml/login`;
        // 如果是员工登录，存一下openid，appid，returnurl
        // window.localStorage.setItem('appId', this.$route.query.appid)
        // window.localStorage.setItem('openId', this.$route.query.openid)
        // localStorage.myOpenId = localStorage.openId
      }
      if (!flag) {
        if (
          !window.localStorage.getItem("registerNonHCPInfo") ||
          window.localStorage.getItem("registerNonHCPInfo") == "null"
        ) {
          console.log("0000");
          window.localStorage.removeItem("registerNonHCPInfo");
          this.nonHCPData = {};
        } else {
          console.log("1111");
          this.nonHCPData = JSON.parse(
            window.localStorage.getItem("registerNonHCPInfo")
          );
        }
        if (this.nonHCPData && this.nonHCPData.roleId) {
          this.roleList.forEach((val) => {
            if (val.id == this.nonHCPData.roleId) {
              val.checked = true;
            } else {
              val.checked = false;
            }
          });
        }
      }
      if (flag && this.showQRcode) {
        // 如果是hcp且未关注
        this.$nextTick(() => {
          // 给头部二维码qrCode-container定高，解决安卓软键盘弹出压缩背景图的问题
          let h =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
          this.$nextTick(() => {
            console.log(this.$refs.abc, "abc-----ref");
            this.$refs.abc.style.height = (h * 0.16).toFixed(1) + "px";
          });
        });
      }
    },
    // 获取适应症
    getAllIndicationList(ids = [], items = []) {
      if (!items) {
        items = [];
      }
      console.log(items, "getAllIndicationList");
      // 选中的领域
      this.postData.fieldIds = ids;
      this.postData.selectedFieldItems = items;
      // 查找与当前选中领域相关的适应症
      let arr = [];
      for (let i = 0; i < items.length; i++) {
        let fieldRelatedIndts = this.postData.selectedIndtItems.filter(
          (val) => val.fieldId == items[i].id
        );
        // arr = [...arr, ...fieldRelatedIndts]
        arr = Array.from(new Set([...arr, ...fieldRelatedIndts]));
      }
      console.log(arr, "当前选中领域相关的适应症");
      this.postData.selectedIndtItems = arr;
      this.postData.indications = arr.map((val) => val.id);

      let params = ids;
      this.$axiox.post(`/api/Dict/GetIndications`, params).then((res) => {
        console.log(res, "getIndicationList");
        this.indicationList = res.map((val) => {
          return {
            checked: this.postData.indications.some((item) => item == val.id),
            ...val,
          };
        });
      });
    },
    // 获取 选中的适应症
    getSelectedIndication(ids = [], items = []) {
      this.postData.indications = ids;
      this.postData.selectedIndtItems = items;
    },
    // 获取用户信息
    getUserInfo() {
      let data = {
        openId: this.openId,
      };
      this.$axiox.postNoRes("/Login/WxUserInfo", data).then((msg) => {
        console.log(msg, "getUserInfo");
        // 基本信息
        this.postData.docName = msg.data.docName;
        this.postData.hcpType = msg.data.hcpType;
        this.postData.department = msg.data.department;
        this.postData.headImageUrl = msg.data.headImageUrl;
        this.postData.Province = msg.data.province;
        // 领域/适应症
        this.postData.selectedIndtItems = msg.data.indications;
        this.postData.indications = msg.data.indications.map((val) => val.id);
        this.postData.selectedFieldItems = msg.data.fields;
        this.postData.fieldIds = msg.data.fields.map((val) => val.id);

        this.$forceUpdate();
      });
    },
    chooseRole(item, index) {
      item.checked = true;
      for (let i = 0; i < this.roleList.length; i++) {
        if (i != index) {
          this.roleList[i].checked = false;
        }
      }
      let roleArr = this.roleList.filter((item) => item.checked);
      this.nonHCPData.roleId = roleArr[0].id;
      this.nonHCPData.roleName = roleArr[0].roleName;
    },
    recoverFieldList(list) {
      this.fieldList = list;
    },
    recoverIndicationList(list) {
      this.indicationList = list;
    },
    // 获取非医疗相关人员角色 /api/NonHCPCustomer/GetNonRoles
    getNonHCPRoles() {
      this.$axiox.get(`/api/NonHCPCustomer/GetNonRoles`).then((res) => {
        console.log(res, "getNonHCPRoles");
        this.roleList = res.map((val) => {
          return {
            checked: false,
            ...val,
          };
        });
      });
    },
    // 非医疗相关人士注册
    registerNonHCP() {
      console.log(this.nonHCPData, "非医疗相关人士注册！非医疗相关人士注册！");
      // let roleArr = this.roleList.filter(item => item.checked)
      // console.log(roleArr, 'roleArr')
      if (this.nonHCPData.name && this.nonHCPData.institution) {
        // 校验姓名
        // let reg = /^((?![\u3000-\u303F])[\u2E80-\uFE4F]|\·)*(?![\u3000-\u303F])[\u2E80-\uFE4F](\·)*$/;
        // if (!reg.test(this.nonHCPData.name)) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   return false;
        // }
        // if (this.nonHCPData.name.length < 2 || this.nonHCPData.name.length > 9) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   return false;
        // }
        // 校验机构
        let reg1 = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
        if (!reg1.test(this.nonHCPData.institution)) {
          this.$commonJs.showTips("请您输入正确的组织/机构");
          return false;
        }
        if (
          this.nonHCPData.institution.length < 2 ||
          this.nonHCPData.institution.length > 32
        ) {
          this.$commonJs.showTips("请您输入正确的组织/机构");
          return false;
        }
        // 校验隐私及使用政策
        if (!this.agree) {
          this.$commonJs.showTips("请先同意武田电子化信息平台隐私及使用政策！");
          return;
        }
        let params = {
          name: this.nonHCPData.name,
          institution: this.nonHCPData.institution,
          meetingemscode: this.meetingemscode,
          roleId: 1, // 暂时写死
          roleName: "实习生", // 暂时写死
          openId: this.openId,
        };
        this.$axiox
          .post(`/api/NonHCPCustomer/AddNonHCPCustomer`, params)
          .then((res) => {
            window.localStorage.setItem("nonHCP", true);
            console.log(res, "registerNonHCP");
            this.$commonJs.mobileDoubleComfirm({
              buttonType: "1",
              type: "warning",
              title: "提示",
              content: `您已注册成功`,
              successFun: (p) => {
                // 注册成功删除暂存的用户信息
                window.localStorage.removeItem("registerNonHCPInfo");
                window.localStorage.removeItem("registerUserInfo");
                if (this.returnurl) {
                  setTimeout((p) => {
                    this.nonHCPData.openId = this.openId;
                    window.location.href = this.$commonJs.returnQuery2(
                      decodeURIComponent(this.returnurl),
                      this.nonHCPData
                    );

                    // if(this.FromMedical){
                    //   window.location.href= decodeURIComponent(this.returnurl);
                    //   }else{
                    //   window.location.href = this.$commonJs.returnQuery2(
                    //    decodeURIComponent(this.returnurl),
                    //    this.nonHCPData
                    //  );
                    //   }



                  }, 2000);
                } else {
                  this.$commonJs.closeWindow();
                }
              },
            });
          });
      } else {
        this.$commonJs.showTips("请检查必填项");
      }
    },
    // 获取非医疗相关人士详情
    getNonHCPCustomer(id) {
      this.$axiox
        .get(`/api/NonHCPCustomer/NonHCPCustomer/${id}`)
        .then((res) => {
          console.log(res, "getNonHCPCustomer");
        });
    },
    // 修改非医疗相关人士信息
    updateNonHCPCustomer() {
      console.log(this.nonHCPData, "非医疗相关人士注册！非医疗相关人士注册！");
      let roleArr = this.roleList.filter((item) => item.checked);
      console.log(roleArr, "roleArr");
      if (
        this.nonHCPData.name &&
        this.nonHCPData.institution &&
        roleArr.length > 0
      ) {
        // let reg = /^((?![\u3000-\u303F])[\u2E80-\uFE4F]|\·)*(?![\u3000-\u303F])[\u2E80-\uFE4F](\·)*$/;
        // if (!reg.test(this.nonHCPData.name)) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   return false;
        // }
        // if (this.nonHCPData.name.length < 2 || this.nonHCPData.name.length > 9) {
        //   this.$commonJs.showTips('请您输入正确的姓名')
        //   return false;
        // }
        if (!this.agree) {
          this.$commonJs.showTips("请先同意武田电子化信息平台隐私及使用政策！");
          return;
        }
        let params = {
          name: this.nonHCPData.name,
          institution: this.nonHCPData.institution,
          roleId: roleArr[0].id,
          roleName: roleArr[0].roleName,
          openId: this.openId,
        };
        this.$axiox.put(`/api/NonHCPCustomer`, params).then((res) => {
          console.log(res, "updateNonHCPCustomer");
        });
      } else {
        this.$commonJs.showTips("请检查必填项");
      }
    },
    delHcp(e) {
      e.returnValue = false;
      e.preventDefault();
      this.$commonJs.mobileDoubleComfirm({
        buttonType: "2",
        type: "warning",
        title: "提示",
        content:
          "注销账户后，您将不能获得针对医疗卫生专业人士的相关信息，请问确认继续吗？",
        successFun: () => {
          this.$axiox
            .del(
              `/api/hcp/DelHcpCustomer?openId=${localStorage.openId}&channel=M`
            )
            .then((res) => {
              console.log(res, "delHcp");
              if (res === "True") {
                var Logoutcount = "";
                this.$axiox
                  .del(
                    `/api/hcp/GetLogoutTimes?openId=${localStorage.openId}&channel=M`
                  )
                  .then((p) => {
                    Logoutcount = p;

                    if (Logoutcount != 3 && Logoutcount != 0) {
                      this.$commonJs.showTips(
                        "注销成功，您还有 " +
                          Logoutcount +
                          " 次注销机会，请谨慎注销！"
                      );
                    } else if (Logoutcount == 3) {
                      this.$commonJs.showTips("您已注销成功");
                    } else if (Logoutcount == 0) {
                      this.$commonJs.showTips(
                        "注销成功，您已到达注销次数上限，请谨慎注销！"
                      );
                    }
                  });

                window.setTimeout((t) => {
                  this.$commonJs.closeWindow();
                }, 3000);
              } else if (res === "Forbid") {
                //this.$commonJs.showTips('请检查必填项')
                this.$commonJs.alertTips({
                  type: "warning",
                  title: "提示",
                  content: "注销失败，您已到达注销次数上限！",
                  stayTime: 5,
                });
                return;
              }
            });
        },
        errorFun: (err) => {},
      });
    },
  },
  watch: {
    postData: {
      handler(newData) {
        let fields = newData.selectedFieldItems
          ? newData.selectedFieldItems.map((val) => val.name).join(",")
          : "";
        let indications = newData.selectedIndtItems
          ? newData.selectedIndtItems.map((val) => val.name).join(",")
          : "";
        this.postData.fieldStr = fields;
        this.postData.indicationStr = indications;
        if (fields || indications) {
          this.postData.fields_indications = fields + " / " + indications;
        } else {
          this.postData.fields_indications = "";
        }

        if (newData.fieldIds.length > 0) {
          this.fieldList.forEach((item) => {
            item.checked = newData.fieldIds.some((val) => val == item.id);
          });
        }
        if (newData.indications.length > 0) {
          this.indicationList.forEach((item) => {
            item.checked = newData.indications.some((val) => val == item.id);
          });
        }
        this.$forceUpdate();
        if (
          this.userStatus == 1 ||
          (this.stepNext && this.isEdit) ||
          (!this.stepNext && this.isEdit)
        ) {
          window.localStorage.removeItem("registerUserInfo");
        } else {
          // 注册之前每次更新都存在本地，如果完成注册则删除 (HCP)
          window.localStorage.setItem(
            "registerUserInfo",
            JSON.stringify(this.postData)
          );
        }
      },
      deep: true,
    },
    nonHCPData: {
      handler(newData) {
        if (
          this.userStatus == 1 ||
          (this.stepNext && this.isEdit) ||
          (!this.stepNext && this.isEdit)
        ) {
          window.localStorage.removeItem("registerNonHCPInfo");
        } else {
          // 注册之前每次更新都存在本地，如果完成注册则删除 (非HCP)
          window.localStorage.setItem(
            "registerNonHCPInfo",
            JSON.stringify(this.nonHCPData)
          );
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
#login {
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background-color: #fff;
  font-size: 15px;
}
.cover {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000;
  z-index: 999;
}
#showImg {
  display: none;
  opacity: 0;
  transition: all 0.5s;
  /* position: fixed; */
  position: absolute; /* 解决二维码不能识别的问题 */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  align-items: center;
  overflow: auto;
  justify-content: center;
}
#showImg > img {
  position: fixed;
  z-index: 1000;
  display: none;
  transition: all 0.5s;
  left: 50% !important;
  top: 20% !important;
  transform: translateX(-50%) !important;
  max-width: 300px;
  max-height: 300px;
}
.tabList {
  width: 100%;
  padding: 0 20px;
  position: absolute;
  margin: 0 auto;
  top: 60px;
  left: 0;
  display: flex;
  box-sizing: border-box;
}
.tabList li {
  width: 50%;
  padding: 5px 0;
  text-align: center;
  font-weight: 700;
  color: #333333;
  border-bottom: 2px solid #bbbbbb;
}
.tabList li.activeTab {
  color: #ef1201;
  border-bottom: 2px solid #ef1201;
}
#employee {
  width: 100%;
  min-height: 400px;
}
.qrcode-box {
  width: 12vh;
  height: 12vh;
  font-size: 12px;
  position: absolute;
  bottom: 5px;
  left: 10px;
}
.qrcode-box img {
  display: block;
  width: 100%;
  height: 100%;
}
.text-box {
  width: calc(100% - 120px);
  height: auto;
  font-size: 12px;
  text-align: center;
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
.noneHCP {
  padding: 2%;
}
.noneHCP .role-list {
  width: 100%;
  margin-bottom: 20px;
  overflow: hidden;
}
.noneHCP .role-item {
  width: 15%;
  height: 20px;
  line-height: 20px;
  padding: 2px;
  /* C5C5C5 */
  color: #999;
  border: 1px solid #999;
  border-radius: 4px;
  float: left;
  text-align: center;
  font-size: 12px;
  margin-right: 20px;
  margin-top: 15px;
}
.noneHCP .activeRole {
  color: #ef1201;
  border: 1px solid #ef1201;
}
.noneHCP .role-item:last-child {
  margin-right: 0;
}
.qrCode-container {
  /* position: fixed; */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 16vh;
  background: #ffffff url("../../assets/qrcode-bcg2.png") no-repeat center;
  background-size: 100% 105%;
  box-sizing: border-box;
  z-index: 2;
}
.nameInput:disabled,
.nameInput[disabled] {
  color: #666 !important;
}
  .loginTxt {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 1.5;
  color: #666666;
  padding-bottom: 5%;
  padding-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/login/mobileLogin.vue